import React from 'react';

import { Box } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { useInboxItemById, useInboxItemParamId } from 'src/hooks/inboxItem';
import { useTestVerificationRequest } from 'src/hooks/testVerificationRequests';
import type { SxProp } from 'src/types/mui';

import { InboxItemEmptyContent } from '../InboxItemEmptyContent';

interface InboxItemContentWrapperProps {
  statusBar: React.ReactNode;
  activityLog?: React.ReactNode;
  stripePaymentStatus?: React.ReactNode;
}

export const InboxItemContentWrapper: React.FC<
  React.PropsWithChildren<InboxItemContentWrapperProps>
> = ({ children, statusBar, activityLog, stripePaymentStatus }) => {
  const inboxItemId = useInboxItemParamId();
  const { loading: inboxItemLoading } = useInboxItemById(inboxItemId);
  const { loading: testVerificationRequestLoading } = useTestVerificationRequest(inboxItemId);
  const loading = inboxItemLoading || testVerificationRequestLoading;

  if (!inboxItemId) {
    return <InboxItemEmptyContent />;
  }

  if (loading) {
    return (
      <FullscreenLoader
        sx={{
          height: '100%',
        }}
      />
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={4} sx={inboxItemContentWrapperStyles}>
      {statusBar}
      {stripePaymentStatus}
      {children}
      {activityLog}
    </Box>
  );
};

const inboxItemContentWrapperStyles: SxProp = theme => ({
  paddingTop: '40px',
  paddingBottom: '20px',
  paddingX: '32px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: 0,
    paddingX: 0,
  },
});
